import { render, staticRenderFns } from "./HistoryTwoInOne.vue?vue&type=template&id=afe06dce&scoped=true"
import script from "./HistoryTwoInOne.vue?vue&type=script&lang=js"
export * from "./HistoryTwoInOne.vue?vue&type=script&lang=js"
import style0 from "./HistoryTwoInOne.vue?vue&type=style&index=0&id=afe06dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe06dce",
  null
  
)

export default component.exports